import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY as string;

// Use service role key for development if available (bypasses RLS)
const keyToUse = supabaseServiceKey || supabaseAnonKey;
const keyType = supabaseServiceKey ? 'service_role' : 'anon';

// Debug: Log the environment variables to check if they're loaded
console.log('Supabase URL:', supabaseUrl);
console.log(`Using ${keyType} key (first 20 chars):`, keyToUse?.substring(0, 20) + '...');

if (!supabaseUrl || !keyToUse) {
  throw new Error('Missing Supabase environment variables');
}

if (supabaseServiceKey) {
  console.warn('⚠️  WARNING: Using service_role key - this is for DEVELOPMENT ONLY!');
}

export const supabase = createClient(supabaseUrl, keyToUse, {
  auth: {
    persistSession: false,
    autoRefreshToken: false
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  // Add more permissive options for debugging
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'apikey': keyToUse
    }
  }
});

// Test the connection immediately
(async () => {
  try {
    console.log('🔬 Testing Supabase connection...');
    const { data, error } = await supabase.from('lunch_status').select('count').limit(1);
    if (error) {
      console.error('❌ Supabase connection test failed:', error);
    } else {
      console.log('✅ Supabase connection test successful:', data);
    }
  } catch (err) {
    console.error('❌ Supabase connection test error:', err);
  }
})();

// Debug function to check realtime status
export const debugRealtimeStatus = () => {
  console.log('🔍 Realtime Debug Info:');
  console.log('- Supabase client created:', !!supabase);
  console.log('- URL:', supabaseUrl);
  console.log('- Key type:', keyType);
  
  // Try to get realtime status
  const realtime = (supabase as any).realtime;
  const channels = realtime?.channels || {};
  console.log('- Realtime instance:', !!realtime);
  console.log('- Connection state:', realtime?.connection?.connectionState);
  console.log('- Active channels:', Object.keys(channels));
  
  Object.entries(channels).forEach(([name, channel]: [string, any]) => {
    console.log(`  - Channel "${name}":`, {
      state: channel.state,
      subscriptions: channel.bindings?.length || 0,
      topic: channel.topic,
      joinRef: channel.joinRef
    });
  });
  
  // Global listener counts 
  console.log('- Global listener counts:');
  console.log('  - Lunch status listeners:', (window as any).__lunchStatusListeners || 0);
  console.log('  - Orders listeners:', (window as any).__ordersListeners || 0);
  console.log('  - Order members listeners:', (window as any).__orderMembersListeners || 0);
};

// Global function to force refresh realtime
export const refreshRealtime = () => {
  console.log('🔄 Forcing realtime refresh...');
  const realtime = (supabase as any).realtime;
  if (realtime?.connection) {
    realtime.connection.disconnect();
    setTimeout(() => {
      realtime.connection.connect();
      console.log('✅ Realtime connection refreshed');
    }, 1000);
  }
};

// Make functions available globally
(window as any).debugRealtimeStatus = debugRealtimeStatus;
(window as any).refreshRealtime = refreshRealtime;


